
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Gajaanana, shri ganaraaya" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Gajaanana, shri ganaraaya" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Gajaanana Shri Ganaraaya Aarti, Ganesha Aarti, Shri Ganesh Aarti lyrics, anpati Aarti in Marathi, Ganapati Bappa Morya, Gajaanana Aarti lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Gajaanana Shri Ganaraaya Aarti, Ganesha Aarti, Shri Ganesh Aarti lyrics, Ganpati Aarti in Marathi, Ganapati Bappa Morya, Ganesh Bhakti Geet, Gajaanana Aarti lyrics, Ganpati Worship, Ganesh Puja, Gajanana Marathi Aarti, Ganapati prayer, Ganesh Chaturthi Aarti, Ganesh Festival aarti, Shri Ganesh Aarti in Marathi, Devotional aarti, Ganesh worship songs, Marathi Ganesh Aarti, gajanana shri ganraya lyrics marathi, गजानना श्री गणराया, gajanana shri ganraya lyrics in english, gajanana shri ganraya lyrics in marathi, gajanana shri ganraya lyrics'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/morya.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/morya.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Gajaanana, shri ganaraaya | Morya Aarti - गजानना श्री गणराया (मोरयाची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/morya"
        },
        "headline": "Gajaanana, shri ganaraaya - गजानना श्री गणराया (मोरयाची आरती)",
        "name" : "Gajaanana, shri ganaraaya - Morya Aarti",
        "description": "Explore the full lyrics of Aarti 'Gajaanana, shri ganaraaya' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/morya.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  